// composables/useIssueNavigation.js
//
// The single source of truth for navigating to the member-answerable
// collection-issue surfaces from WITHIN the tabbed shell (deep inside a tab, no
// f7router prop available — so we reach through the main view's router, exactly
// as the individual call sites did before this was consolidated).
//
//   openIssue(id) → /issues/:id/  — one decision card (notification deep-link,
//                                   the per-item badge, and the inbox row all
//                                   land on the SAME card).
//   openInbox()   → /issues/      — the "قرارات مطلوبة" hub.
//
// Before this composable the `/issues/...` route strings + the global-router
// hop were re-typed in ItemCard, BoxTotalsBreakdown, and DecisionsInboxBanner.
// Keeping them here means the route + the null-guard live in one place.
//
// NOTE: the page components (IssueDecisionPage / DecisionsInboxPage) navigate
// via their injected `f7router` prop instead — that's correct for page-level
// navigation and is intentionally NOT routed through here.
import { f7 } from 'framework7-vue';

/** The inbox hub's path. Pages navigate with their own f7router — see the note
 *  above — but they build the path from HERE so the route lives in one file. */
export const ISSUES_INBOX_ROUTE = '/issues/';

/** One issue's detail path. Same reason: the only place `/issues/:id/` is spelt. */
export function issueRoute(issueId) {
  return `${ISSUES_INBOX_ROUTE}${issueId}/`;
}

export function useIssueNavigation() {
  /** Open one issue's decision card. No-op when the id is missing.
   *
   *  Since interaction-v2 this is NOT decision-only: the backend's `show` serves
   *  an issue in every status, so a being-handled item opens the same card
   *  read-only (leader's message + full timeline). Callers therefore gate on
   *  `isRoutableIssue(presentation)`, not on "is it my turn" — see
   *  useItemIssuePresentation. */
  function openIssue(issueId) {
    if (issueId == null) return;
    f7?.views?.main?.router?.navigate(issueRoute(issueId));
  }

  /** Open the decisions-required inbox hub. */
  function openInbox() {
    f7?.views?.main?.router?.navigate(ISSUES_INBOX_ROUTE);
  }

  return { openIssue, openInbox };
}
